<div class="sidenav-primary">
  <nav class="nav-primary">
    <a *ngFor="let item of navItems$ | async" routerLink="{{ item.route === 'no-op' ? route.url : '/' + item.route }}" routerLinkActive="{{ item.route === 'no-op' ? '' : 'active' }}" [attr.tabindex]="0" class="nav-item">
      <img src="./assets/images/global/icons/nav/{{ item.categoryIcon }}" alt="{{ item.labelId }}" />
      <span class="label" [innerHTML]="item.labelId | translate"></span>
    </a>
    <a *ngIf="isAdminsite" class="nav-item" href="javascript:;" (click)="openUrl()">
      <img src="./assets/images/global/icons/nav/ico-nav-admin.svg" alt="Admin Site" />
      <span class="label" [innerHTML]="'$common_admin_site' | translate" ></span>
    </a>
  </nav>
</div>
